import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  InputAdornment,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { BASE_URL } from "../../constants";
import { toast } from "react-toastify";
import { useSetRecoilState } from "recoil";
import { authState } from "../../recoil/authAtom";
import { normalizeAuthIdentity } from "../../utils/auth";
import { setCsrfToken } from "../../utils/api";
import { useNavigate } from "react-router-dom";

export default function CentreLogin() {
  const [idPart1, setIdPart1] = useState("");
  const [idPart2, setIdPart2] = useState("");
  const [idPart3, setIdPart3] = useState("");
  const [centrePassword, setCentrePassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const setAuth = useSetRecoilState(authState);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    const centreId = `${idPart1}-${idPart2}-${idPart3}`;

    if (!idPart1 || !idPart2 || !idPart3 || !centrePassword) {
      return setErrorMsg("All fields are required");
    }

    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}api/centre/login`, {
        centreId,
        centrePassword,
      });
      console.log(res.data);
      if (res.data.success) {
        setCsrfToken(res.data.csrfToken);
        setAuth(
          normalizeAuthIdentity(res.data.centre, "centre") || {
            authenticated: true,
            permissions: {},
            sessionType: "centre",
          },
        );
        navigate("/centre/pat-form", { replace: true });
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      setErrorMsg(error.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f4f6f8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 3,
          width: "100%",
          maxWidth: 400,
          borderRadius: 3,
        }}
      >
        <Typography variant="h5" textAlign="center" fontWeight="bold" mb={2}>
          Centre Login
        </Typography>

        <form onSubmit={handleLogin}>
          <Box display="flex" gap={1} mb={2}>
            <TextField
              type="number"
              placeholder="XX"
              inputProps={{ maxLength: 2 }}
              value={idPart1}
              onChange={(e) => setIdPart1(e.target.value)}
              size="small"
              fullWidth
            />
            <TextField
              type="number"
              placeholder="X"
              inputProps={{ maxLength: 1 }}
              value={idPart2}
              onChange={(e) => setIdPart2(e.target.value)}
              size="small"
              fullWidth
            />
            <TextField
              type="number"
              placeholder="X"
              inputProps={{ maxLength: 1 }}
              value={idPart3}
              onChange={(e) => setIdPart3(e.target.value)}
              size="small"
              fullWidth
            />
          </Box>

          <TextField
            label="Password"
            variant="outlined"
            type={showPassword ? "text" : "password"}
            fullWidth
            size="small"
            value={centrePassword}
            onChange={(e) => setCentrePassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {errorMsg && (
            <Typography
              variant="body2"
              color="error"
              textAlign="center"
              sx={{ mb: 2 }}
            >
              {errorMsg}
            </Typography>
          )}

          <Button
            variant="contained"
            fullWidth
            type="submit"
            sx={{ py: 1.2, fontWeight: "bold" }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
